"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const mobx_react_1 = require("mobx-react");
const mobx_1 = require("mobx");
const InputText_1 = __importDefault(require("@Components/Fields/InputText"));
const Button_1 = require("@Components/Buttons/Button");
const validate_1 = require("@App/helpers/validate");
const removers_1 = require("@App/helpers/work-entities/removers");
const fields_validators_1 = require("@App/helpers/work-entities/fields-validators");
const contexts_1 = require("@App/contexts");
class EditSimpleWriter extends react_1.default.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "firstName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.editingWriter.firstName
        }); // max length 60
        Object.defineProperty(this, "firstNameError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "lastName", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.editingWriter.lastName
        }); // max length 200
        Object.defineProperty(this, "lastNameError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "ipiNumber", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: this.props.editingWriter.ipiNumber
        }); // max length 11
        Object.defineProperty(this, "ipiNumberError", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "isDisabled", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "getValue", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (value, id) => {
                value = value.trim();
                switch (id) {
                    case 'firstName':
                        this.firstNameError = (0, fields_validators_1.writerFirstNameInvalidCheck)(value)
                            ? 'Max length 60 symbol. May not include multiple lines.'
                            : '';
                        this.firstName = value;
                        break;
                    case 'lastName':
                        this.lastNameError = (0, fields_validators_1.writerLastNameInvalidCheck)(value)
                            ? 'Max length 200 symbol. may not include multiple lines.'
                            : '';
                        this.lastName = value;
                        break;
                    case 'ipiNumber':
                        this.ipiNumberError =
                            value.length > 11
                                ? 'Сan not be longer 11 characters'
                                : !value.match(/^[0-9]*$/)
                                    ? 'IPI number must contain only numbers'
                                    : (0, validate_1.IPIValidator)(value, false)
                                        ? ''
                                        : 'Invalid IPI number';
                        this.ipiNumber = value.length ? value : null;
                        break;
                    default:
                        break;
                }
                this.validator();
            }
        });
        Object.defineProperty(this, "validator", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const isValid = this.lastName && !this.firstNameError && !this.lastNameError && !this.ipiNumberError;
                this.isDisabled = !isValid;
            }
        });
        Object.defineProperty(this, "editWriter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                const workDraftFromLocal = this.context.workStore.workDraftLocal;
                const editingWriterId = this.props.editingWriter.localId;
                if (!workDraftFromLocal || !editingWriterId) {
                    return;
                }
                const writers = workDraftFromLocal.writers;
                const indexOfWriter = writers.map((writer) => writer.localId).indexOf(editingWriterId);
                const updatedWriter = {
                    localId: editingWriterId,
                    firstName: this.firstName ? this.firstName : null,
                    lastName: this.lastName, // REQUIRED FIELD
                    ipiNumber: this.ipiNumber ? this.ipiNumber.padStart(11, '0') : null,
                    roleCode: null,
                    writerShare: 0,
                };
                const updatedWritersArray = (0, removers_1.setItemToArrayByIndex)(writers, +indexOfWriter, updatedWriter);
                const updatedWorkDraft = Object.assign(Object.assign({}, workDraftFromLocal), { writers: updatedWritersArray });
                this.context.workStore.setWorkDraftToLocal(updatedWorkDraft);
                this.props.closePopupFunc();
            }
        });
        (0, mobx_1.makeObservable)(this, {
            firstName: mobx_1.observable,
            firstNameError: mobx_1.observable,
            lastName: mobx_1.observable,
            lastNameError: mobx_1.observable,
            ipiNumber: mobx_1.observable,
            ipiNumberError: mobx_1.observable,
            isDisabled: mobx_1.observable,
            getValue: mobx_1.action,
            validator: mobx_1.action,
            editWriter: mobx_1.action,
        });
    }
    componentDidMount() {
        // Not a great way to trigger on-load validation
        this.getValue(this.firstName ? this.firstName : '', 'firstName');
        this.getValue(this.lastName ? this.lastName : '', 'lastName');
        this.getValue(this.ipiNumber ? this.ipiNumber : '', 'ipiNumber');
    }
    render() {
        return (react_1.default.createElement("div", { className: "writer-sub-form-component" },
            react_1.default.createElement("h2", null, "Edit Writer"),
            react_1.default.createElement("h5", { className: 'medium subtitle' }, "Enter the Writer's details"),
            react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'firstName', label: 'First Name', value: this.firstName, onChange: this.getValue, isEscapeNewlines: true, errorMessage: this.firstNameError }),
            react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'lastName', label: 'Last Name', value: this.lastName, onChange: this.getValue, isEscapeNewlines: true, errorMessage: this.lastNameError }),
            react_1.default.createElement(InputText_1.default, { mainColor: true, id: 'ipiNumber', label: 'IPI Number', assistiveText: 'Required', value: this.ipiNumber, onChange: this.getValue, errorMessage: this.ipiNumberError }),
            react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: this.editWriter, disabled: this.isDisabled }, "Edit Writer")));
    }
}
exports.default = (0, mobx_react_1.observer)(EditSimpleWriter);
EditSimpleWriter.contextType = contexts_1.StoresContext;
